'use client';

import { useToast } from '@wwe-portal/ui/components/toast';
import { addDDError } from '@wwe-portal/web/libs/analytics/datadog';
import {
  APIError,
  UnauthorizedError,
} from '@wwe-portal/web/services/client/error';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';

export const isAPIError = (
  error: unknown,
  code?: number
): error is APIError => {
  return error instanceof APIError && (code == null || error.code === code);
};

export const useHandleCommonError = () => {
  const t = useTranslations();
  const { toast } = useToast();
  return useCallback(
    (error: unknown) => {
      if (error instanceof UnauthorizedError) {
        toast({
          content: t('your_session_has_expired'),
          variant: 'error',
        });
        return;
      }
      if (isAPIError(error) && error.originError.response?.data['message']) {
        toast({
          content: error.originError.response?.data['message'],
          variant: 'error',
        });
        return;
      }

      // log unexpected error
      addDDError(error);
      toast({
        content: t('something_went_wrong'),
        variant: 'error',
      });
    },
    [toast, t]
  );
};
